import * as types from '../costants/ActionTypes'
import axios from "axios";
import {USER_URL} from "../costants/Urls";
import {setCartData, setCartState} from "./nCartAppActions";

const post_config = {
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFToken',
        withCredentials: true
      }


export const setUserData = data => ({
  type: types.SET_USER_DATA,
  data
});


export const setUserToCart = () =>  (dispatch, getState) => {

    const current_state = getState();
    dispatch(setCartState('FETCHING'));

    axios.post(USER_URL, current_state.nuser, post_config)
      .then(res => {

        if (res.status === 200 || res.status === 201){

            dispatch(setUserData(res.data.user));
            dispatch(setCartData(res.data.cart));
            dispatch(setCartState('READY'));

        }else{

            dispatch(setCartState('ERROR'));
        }

      })
      .catch(err => {

        dispatch(setCartState('ERROR'));
      });

};